import React, { useState, useEffect, useCallback } from 'react';
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Button,
  Chip
} from '@mui/material';
import { getResumenMensual } from '../services/api';

const MonthlySummary = () => {
  const [resumen, setResumen] = useState(null);
  const [fechaSeleccionada, setFechaSeleccionada] = useState(new Date());

  // CORREGIDO: Usar useCallback para loadResumenMensual
  const loadResumenMensual = useCallback(async () => {
    try {
      const year = fechaSeleccionada.getFullYear();
      const month = fechaSeleccionada.getMonth() + 1;
      const response = await getResumenMensual(year, month);
      setResumen(response.data);
    } catch (error) {
      console.error('Error loading monthly summary:', error);
    }
  }, [fechaSeleccionada]); // CORREGIDO: Añadida dependencia

  useEffect(() => {
    loadResumenMensual();
  }, [loadResumenMensual]); // CORREGIDO: Añadida loadResumenMensual como dependencia

  const tieneEntradaSalida = (dia) => {
    return dia.trabajos.some(trabajo => trabajo.entrada_salida);
  };

  if (!resumen) {
    return (
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Resumen Mensual
        </Typography>
        <Typography>Cargando...</Typography>
      </Paper>
    );
  }

  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Resumen Mensual - {fechaSeleccionada.toLocaleDateString('es-ES', { 
          month: 'long', 
          year: 'numeric' 
        })}
      </Typography>

      <Box sx={{ mb: 2, display: 'flex', gap: 1 }}>
        <Button 
          variant="outlined"
          onClick={() => {
            const nuevaFecha = new Date(fechaSeleccionada);
            nuevaFecha.setMonth(nuevaFecha.getMonth() - 1);
            setFechaSeleccionada(nuevaFecha);
          }}
        >
          Mes Anterior
        </Button>
        
        <Button 
          variant="outlined"
          onClick={() => setFechaSeleccionada(new Date())}
        >
          Este Mes
        </Button>
        
        <Button 
          variant="outlined"
          onClick={() => {
            const nuevaFecha = new Date(fechaSeleccionada);
            nuevaFecha.setMonth(nuevaFecha.getMonth() + 1);
            setFechaSeleccionada(nuevaFecha);
          }}
        >
          Mes Siguiente
        </Button>
      </Box>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Fecha</TableCell>
              <TableCell>Entrada</TableCell>
              <TableCell>Salida</TableCell>
              <TableCell>Total Horas</TableCell>
              <TableCell>Ingresos</TableCell>
              <TableCell>Estado</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {resumen.resumen_por_dia.map((dia) => (
              <TableRow key={dia.fecha}>
                <TableCell>
                  {new Date(dia.fecha).toLocaleDateString('es-ES')}
                </TableCell>
                <TableCell>{dia.hora_entrada}</TableCell>
                <TableCell>{dia.hora_salida}</TableCell>
                <TableCell>{dia.total_horas}h</TableCell>
                <TableCell>{dia.ingresos_dia}€</TableCell>
                <TableCell>
                  {tieneEntradaSalida(dia) && (
                    <Chip label="E/S" color="error" size="small" />
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ mt: 3, p: 2, bgcolor: 'primary.main', color: 'white', borderRadius: 1 }}>
        <Typography variant="h6">
          Totales del Mes
        </Typography>
        <Typography>Horas totales: {resumen.total_horas_mes}h</Typography>
        <Typography>Ingresos totales: {resumen.total_ingresos_mes}€</Typography>
        <Typography>Tarifa: {resumen.tarifa_hora}€/hora</Typography>
      </Box>

      <Box sx={{ mt: 2 }}>
        <Button variant="contained" color="primary">
          Exportar a PDF
        </Button>
      </Box>
    </Paper>
  );
};

export default MonthlySummary;